import * as React from 'react';

import {Popover} from 'shells/popover/popover';

import {useGetSessionUser} from '../../../core/use-get-session-user';

import {Header} from './header';
import {Logout} from './logout';
import {MenuItems} from './menu-items';

import styles from './user-menu-popover.module.css';

type MenuVariant = 'full' | 'logout-only';

type Props = {
    userMenuRef: HTMLElement | null | undefined;
    setIsUserMenuOpened: (isUserMenuOpened: boolean) => void;
    variant?: MenuVariant;
    setIsReferAFriendModalOpen: (isReferAFriendModalOpen: boolean) => void;
    setIsLeaveAReviewModalOpen: (setIsLeaveAReviewModalOpen: boolean) => void;
};

export const UserMenuPopover = (props: Props) => {
    const {variant = 'full'} = props;

    const {user} = useGetSessionUser();

    if (!user) return null;

    return (
        <Popover
            anchor={props.userMenuRef}
            onBlur={() => props.setIsUserMenuOpened(false)}
            location='bottom-left'
            hideNub={true}
            offsetPosition={-10}
            customStyles={{
                maxHeight: 'calc(100vh - 40px)',
            }}
        >
            <div className={styles['popover-container']}>
                <Header user={user} />
                {variant === 'full' && (
                    <MenuItems
                        user={user}
                        setIsUserMenuOpened={props.setIsUserMenuOpened}
                        setIsReferAFriendModalOpen={props.setIsReferAFriendModalOpen}
                        setIsLeaveAReviewModalOpen={props.setIsLeaveAReviewModalOpen}
                    />
                )}
                {variant === 'logout-only' && (
                    <Logout onClose={() => props.setIsUserMenuOpened(false)} />
                )}
            </div>
        </Popover>
    );
};
